<template>
  <v-text-field
    v-model="inputValue"
    :type="(changeType(), integer)"
    :hidden="schema.hidden"
    :value="inputValue"
    :name="schema.fullkey"
    :label="schema.label"
    :readonly="schema.readonly"
    :disabled="schema.disabled"
    :required="schema.required"
    autocomplete="new-password"
    step
    :rules="rules()"
    :min="schema.minValue"
    :max="schema.maxValue"
    min-width="290px"
    :class="refSpecs != null ? 'mt-0 pt-0' : null"
    @keypress="callMethod"
    @input="emitInput()"
    @change="emitInput()"
  >
    <v-tooltip
      v-if="schema.description && schema.description.length > 0"
      slot="append"
      left
    >
      <v-icon slot="activator">info</v-icon>
      <div class="vjsf-tooltip" v-html="schema.description" />
    </v-tooltip>

    <!-- begin ref buttons -->
    <v-tooltip
      v-if="refSpecs != null"
      :slot="
        refSpecs.selectBtn != null && refSpecs.selectBtn.placement != null
          ? refSpecs.selectBtn.placement
          : 'append'
      "
      color="white grey--text"
      left
    >
      <v-btn slot="activator" icon class="ma-0" @click="$emit('refShowList')">
        <v-icon>find_replace</v-icon>
      </v-btn>
      <div class="vjsf-tooltip">
        {{
          refSpecs.selectBtn != null && refSpecs.selectBtn.description != null
            ? refSpecs.selectBtn.description
            : 'Select'
        }}
      </div>
    </v-tooltip>
    <v-tooltip
      v-if="refSpecs != null"
      :slot="
        refSpecs.clearBtn != null && refSpecs.clearBtn.placement != null
          ? refSpecs.clearBtn.placement
          : 'append'
      "
      color="white grey--text"
      left
    >
      <v-btn
        slot="activator"
        icon
        class="ma-0"
        @click="$emit('refClearSelection')"
      >
        <v-icon>clear</v-icon>
      </v-btn>
      <div class="vjsf-tooltip">
        {{
          refSpecs.clearBtn != null && refSpecs.clearBtn.description != null
            ? refSpecs.clearBtn.description
            : 'Clear'
        }}
      </div>
    </v-tooltip>
    <!-- end ref buttons -->
  </v-text-field>
</template>

<script>
import { Utils } from '../Utils'
var utils = new Utils()

export default {
  name: 'RDNumberWidget',
  props: {
    schema: {
      type: Object,
      required: true
    },
    value: {
      type: Number,
      default: null
    },
    refSpecs: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      inputValue: this.value || null,
      inputValueStr: '',
      integer: ''
    }
  },
  methods: {
    changeType() {
      if (
        this.schema.numberType !== undefined &&
        this.schema.numberType === 'integer'
      ) {
        this.integer = 'number'
      }
    },
    emitInput: function() {
      if (this.schema.transmit != undefined)
        this.$emit('transmit', this.schema.transmit, this.inputValue)
      if (this.inputValue == '') {
        this.$emit('input', null)
      } else {
        this.$emit('input', parseFloat(this.inputValue))
      }
    },
    callMethod(event) {
      var re = /^[-+]?[1-9]*\d+\.?[1-9]*\d*$/
      var re2 = /^[-+]?[0-9]*\d$/
      var key = String.fromCharCode(
        !event.charCode ? event.which : event.charCode
      )

      var tempInputValue
      if (this.inputValue == null) {
        tempInputValue = key
      } else {
        tempInputValue = this.inputValue + key
      }
      if (tempInputValue === '-') {
        return true
      }
      if (this.schema.numberType === 'decimal') {
        if (!re.test(tempInputValue)) {
          event.preventDefault()
          return false
        }
      } else {
        if (!re2.test(tempInputValue)) {
          event.preventDefault()
          return false
        }
      }
    },

    rules: function() {
      if (this.schema.rules == undefined) return
      var rules = []
      if (this.schema.rules.required == true)
        rules = rules.concat(utils.getRequiredRules())
      return rules
    },

    countDecimals(value) {
      if (Math.floor(value) !== value) return 0
      return value.split('.')[1].length || 0
    }
  }
}
</script>
